import { mq, Text, styled, spacing } from '@thg-commerce/gravity-theme'
import { Button } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

export const MacroResultsContainer = styled.div`
  max-width: 100%;
  text-align: center;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.grey};
  border-radius: ${spacing(1)};
`

export const MacroResultsTitle = styled.p`
  ${Text('large1', 'alternate')};
  padding: ${spacing(4)} ${spacing(2)} 0;
  text-align: center;
  word-break: break-all;
  overflow-wrap: break-word;
  color: ${(props) => props.theme.colors.palette.greys.darker};
`

export const MacroResultsGrid = styled(Grid)`
  margin-bottom: 0;
`

export const MacroResultsGridItem = styled(GridItem)`
  padding-top: ${spacing(7)};
  overflow-wrap: break-word;
`

export const MacroResultsLabel = styled.p`
  ${Text('medium1', 'alternate')};
  padding-top: ${spacing(4)};
  color: ${(props) => props.theme.colors.palette.greys.darker};
`

export const MacroResultsValue = styled.p`
  ${Text('medium1', 'default')};
  padding-top: ${spacing(2)};
  color: ${(props) => props.theme.colors.palette.greys.darker};
`

export const MacroResultsButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing(7)} ${spacing(4)} ${spacing(4)};
  justify-content: center;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    flex-direction: row;
    padding: ${spacing(7)} ${spacing(7)} ${spacing(4)};
  }
`

export const MacroResultsCalculateAgainLink = styled(Button)`
  margin: ${spacing(2)} 0 0;

  &:hover,
  &:focus,
  &:active {
    margin: ${spacing(2)} 0 0;
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    align-self: center;
    margin: 0 0 0 ${spacing(10)};

    &:hover,
    &:focus,
    &:active {
      align-self: center;
      margin: 0 0 0 ${spacing(10)};
    }
  }
`
